import { forwardRef } from 'react';

import { LocationFilledSize16 } from '@hh.ru/magritte-ui/icon';

import getDataQa from 'src/utils/getDataQa';

import styles from './styles.less';

const DATA_QA_CONTAINER = 'geo-location-button';

interface Props {
    cityName: string;
    onClick: () => void;
}

const GeoLocationButton = forwardRef<HTMLButtonElement, Props>(({ cityName, onClick }, ref) => (
    <button className={styles.button} onClick={onClick} role="button" ref={ref} data-qa={getDataQa(DATA_QA_CONTAINER)}>
        <LocationFilledSize16 />
        {cityName}
    </button>
));

export default GeoLocationButton;
